
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 45.7h13.5V13.5h32.2V0H0zM82.3 0v13.5h32.2v32.2H128V0zM128 82.3h-13.5v32.2H82.3V128H128zM45.7 128v-13.5H13.5V82.3H0V128z"}}),_c('path',{attrs:{"d":"M13.5 13.5V23l22.7 22.7 9.5-9.5L23 13.5zm101 0H105L82.3 36.2l9.5 9.5L114.5 23zm0 101V105L91.8 82.3l-9.5 9.5 22.7 22.7zm-101 0H23l22.7-22.7-9.5-9.5L13.5 105z"}})])
          )
        }
      }
    